import { api } from "@/lib/api";

const urlBase64ToUint8Array = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () =>
  typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export async function currentPushSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/push-sw.js");
  return reg ? reg.pushManager.getSubscription() : null;
}

/** Asks permission (if needed) and returns a PushSubscription for this device. Throws with a friendly message on denial. */
export async function ensurePushSubscription() {
  if (!pushSupported()) throw new Error("Push isn't supported in this browser");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications were blocked for this site");
  const reg = await navigator.serviceWorker.register("/push-sw.js");
  await navigator.serviceWorker.ready;
  const existing = await reg.pushManager.getSubscription();
  if (existing) return existing;
  const { data: { key } } = await api.get("/push/vapid-public-key");
  return reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(key) });
}
